import { Component } from 'react'
import PropTypes from 'prop-types'
import slugify from 'react-slugify'

class TaggingPrice extends Component {
  constructor (props) {
    super(props)

    this.state = {
      sendGTM: false
    }
  }

  addDataLayer (productSku, productName, productPrice, productIdentifier, quantity, productPosition) {
    window.dataLayer = window.dataLayer || []
    if (this.props.type === 'removeCart') {
      window.dataLayer.push({
        'event': 'removeFromCart',
        'eventCategory': 'enhanced-ecommerce',
        'eventAction': 'removeFromCart',
        'eventLabel': productSku + ':removeFromCart',
        'ecommerce': {
          'remove': {
            'products': [{
              'metric2': productPrice ? productPrice.cash : undefined,
              'name': slugify(productName, { delimiter: ' ' }),
              'id': productSku,
              'price': productPrice ? productPrice.points : undefined,
              'category': undefined,
              'quantity': quantity
            }]
          }
        }
      })
    }
    this.setState({ sendGTM: true })
  }

  render () {
    if (this.state.sendGTM === false && this.props.price) {
      this.addDataLayer(this.props.sku, this.props.name, this.props.price, this.props.identifier, this.props.quantity, this.props.position)
    }
    return ''
  }
}

TaggingPrice.propTypes = {
  sku: PropTypes.string.isRequired,
  price: PropTypes.object,
  name: PropTypes.string,
  quantity: PropTypes.string,
  identifier: PropTypes.string,
  position: PropTypes.string,
  type: PropTypes.string
}

export default TaggingPrice



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/TaggingPrice.js